import {
  LIST_ASSET_EVENTS,
  SET_ASSET_EVENTS
} from '../actionTypes'
import { apiAction } from './api'

export const listAssetEvents = assetId => apiAction({
  url: `/assets/${assetId}/events`,
  onSuccess: (events) => {
    return setAssetEvents(assetId, events)
  },
  label: LIST_ASSET_EVENTS,
  resourceId: assetId,
})

const setAssetEvents = (assetId, events) => {
  return {
    type: SET_ASSET_EVENTS,
    events,
    assetId,
  }
}